export default "__VITE_ASSET__gfrJvU75__"